import classes from './Card.module.css';

const Card: React.FC<{clsCard?: string; children?: React.ReactNode}> = (props) => {
  const aux = `${classes.card} ${props.clsCard}`;
  return <div className={aux}>{props.children}</div>;
};

export default Card;
